export default __webpack_public_path__ + "static/media/cctv-kasim.1d54f31b.jpg";